import * as categoriesActions from './actions';
import * as userActions from '../user/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isCategoriesFetching: false,
    errorMessage: '',
    listAllCategories: null,

    isSourcesFetching: false,
    // errorMessage: '',
    // listAllSources: null,
    listAllSources: [
        { id: 1791, name: 'Gudok.ru', url: 'https://gudok.ru' },
        { id: 1747, name: 'Nota Bene: официальный блог Евгения Касперского', url: 'https://eugene.kaspersky.ru' },
        { id: 1786, name: 'ТГ канал "Утечки информации"', url: 'https://t.me/dataleak' },
        { id: 1787, name: 'ТГ канал "Data1eaks | Утечки баз данных"', url: 'https://t.me/data1eaks' },
        { id: 1785, name: 'Cnews.ru', url: 'https://www.cnews.ru' },
        { id: 1750, name: 'Интерфакс', url: 'https://www.interfax.ru' },
        { id: 1746, name: 'Хабр', url: 'https://habr.com' },
        {
            id: 1792,
            name: 'ТГ канал "Листок бюрократической защиты информации"',
            url: 'https://t.me/bureaucraticsecurity',
        },
        // { id: 1749, name: 'РБК', url: 'https://www.rbc.ru' },
        { id: 1783, name: 'Коммерсантъ', url: 'https://www.kommersant.ru' },
        { id: 1790, name: 'Anti-malware.ru', url: 'https://www.anti-malware.ru' },
        { id: 1784, name: 'itWeek', url: 'https://www.itweek.ru' },
        { id: 1748, name: 'Ведомости', url: 'https://www.vedomosti.ru' },
        { id: 1788, name: 'Известия', url: 'https://iz.ru' },
        { id: 1661, name: 'SecurityLab.ru', url: 'https://www.securitylab.ru' },
    ],
};

export const categoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case categoriesActions.IS_CATEGORIES_FETCHING:
            return {
                ...state,
                errorMessage: action.errorMessage,
            };

        case categoriesActions.CATEGORIES_FETCHING_ERROR:
            return {
                ...state,
                isCategoriesFetching: action.value,
            };

        case categoriesActions.GET_ALL_CATEGORIES:
            return {
                ...state,
                listAllCategories: action.listCategories,
            };

        // ----------------------------------------------------------------

        case categoriesActions.IS_SOURCES_FETCHING:
            return {
                ...state,
                errorMessage: action.errorMessage,
            };

        case categoriesActions.SOURCES_FETCHING_ERROR:
            return {
                ...state,
                isSourcesFetching: action.value,
            };

        case categoriesActions.GET_ALL_SOURCES:
            return {
                ...state,
                listAllSources: action.listSources,
            };

        // ----------------------------------------------------------------

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 7+++');
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 5+++');
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/categories/reducer.js